import { forwardRef } from 'react'

import { FieldError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { GENDER } from 'entities/user/module'

import s from './styles.module.scss'

interface Props {
  value?: GENDER
  error?: FieldError
  onBlur?: () => void
  onChange: (value: GENDER) => void
}

export const GenderSelect = forwardRef<HTMLButtonElement, Props>(
  ({ value, onChange, onBlur, error }, ref) => {
    const { t } = useTranslation()

    return (
      <div className={s.wrapper}>
        <div className={s.genders}>
          <button
            ref={ref}
            type="button"
            className={clsx(
              s.genderBtn,
              value === GENDER.MALE && s.active,
              !value && error && s.errorBtn,
              'semi-bold-14',
            )}
            onClick={() => onChange(GENDER.MALE)}
            onBlur={onBlur}
          >
            {t('gender_male')}
          </button>

          <button
            type="button"
            className={clsx(
              s.genderBtn,
              value === GENDER.FEMALE && s.active,
              !value && error && s.errorBtn,
              'semi-bold-14',
            )}
            onClick={() => onChange(GENDER.FEMALE)}
            onBlur={onBlur}
          >
            {t('gender_female')}
          </button>
        </div>

        {error && <p className={s.error}>{error?.message}</p>}
      </div>
    )
  },
)
